import React, { Component } from "react";
import { ConfigurationModes } from "./hcs-constants";

export default class HcsNavBarItem extends Component {
    constructor(props) {
        super(props);

        this.isVisible = this.isVisible.bind(this);
        this.groupChanged = this.groupChanged.bind(this);
    }

    isVisible() {
        var groupVisible = false;

        this.props.data.attributes.forEach(function(element) {
            groupVisible |= element.info.visible;
        });

        return groupVisible;
    }

    groupChanged(groupId, sender) {
        const { subConfigMode, currentGroup } = this.props;

        let locked = subConfigMode == ConfigurationModes.SubConfigurationTopMenu;

        if(this.isVisible()) {
            if(currentGroup !== groupId) {
                if(!locked) {
                    this.props.onGroupChanged(groupId, sender);
                }
            } else {
                this.props.onGroupChanged("TOGGLE_VISIBILITY");
            }
        }
    }

    itemClasses() {
        const { data, currentGroup } = this.props;

        let itemClasses = [];

        if(data.finished) itemClasses.push("hcs-fin");
        if(data.inProgress) itemClasses.push("hcs-in-progress");
        //if(data.lastActive) itemClasses.push("hcs-last-active");      //-- Nur zum Testen - Beim Reset wird aktuell immer die nächste Gruppe hervorgehoben...
        if(currentGroup === data.groupId) itemClasses.push("hcs-cur");

        return itemClasses;
    }

    render() {
        const { data, groupIndex } = this.props;

        let itemClasses = this.itemClasses();

        let svgIconName = this.props.iconMapping[data.groupId];

        return (
            <li gid={data.groupId} className={itemClasses.length ? itemClasses.join(" ") : null}>
                <a title={data.groupTrans} onClick={_ => this.groupChanged(data.groupId, "HcsNavBarItem") }>
                    <em>
                        {groupIndex}
                        <svg icon-id={svgIconName} version="2.0">
                            <use href={"#" + svgIconName} ></use>
                        </svg>
                    </em>
                    <span>{data.groupTrans}</span>
                </a>
            </li>
        );
    }
}
